/**
 * AuthHeader — the canonical SystemDox header in its signed-out variant,
 * wrapped in the same chrome (border + bg + `px-4 py-3`) as the AppShell and
 * CaptureShell headers, so /login and /signup keep the header every other
 * surface shows.
 */

import { SystemDoxHeader } from '@/components/layout/SystemDoxHeader';

export function AuthHeader() {
  return (
    <header className="sticky top-0 z-10 flex shrink-0 items-center border-b border-border bg-card px-4 py-3">
      <SystemDoxHeader signedOut />
    </header>
  );
}
